import React from 'react';
import Counter from './Counter';

export default class Demo extends React.Component {

  render() {
    return (
      <div>
        <Counter count={1}/>
        <Counter count={12}/>
        <Counter count={123}/>
        <Counter count={1234}/>
      </div>
    )
  }

}